import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (params) => {
  return await dponetAPI.get('/phishing_templates', { params })
}

const show = async (templateId) => {
  return await dponetAPI.get(`/phishing_templates/${templateId}`)
}

const sendEmailTest = async (templateId) => {
  return await dponetAPI.post(
    `/phishing_templates/${templateId}/send_email_test`,
  )
}

const phishingTemplates = {
  get,
  show,
  sendEmailTest,
}

export default phishingTemplates
